import { Theme, css } from '@emotion/react';

const shadowSize = '2px';
export const tockLogoHeadingWidthPx = '86px';
export const tockLogoHeadingWidthDesktopPx = '90px';

export const tockLogoCore = css`
  display: block;
  fill: currentColor;
  height: auto;
  width: 100%;
`;

export const computeTockLogoAnchor = ({ breakpoints, colors, interactiveStates }: Theme) => css`
  color: ${colors.bgPrimaryBase};
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  width: ${tockLogoHeadingWidthPx};

  ${breakpoints.up('sm')} {
    width: ${tockLogoHeadingWidthDesktopPx};
  }

  ${interactiveStates.focus(css`
    outline: solid ${shadowSize} ${colors.borderPrimaryBase};
  `)}
`;
